import React from 'react'
const Footer = () => {

  return (
    
    <>

    <footer className="footer">
      <p className="signature"> Created by V. Sayed Nowshad</p>
    </footer>

    </>
  );
}

export default Footer